<template>
  <FitbitModal
    v-if="fitbitModal"
    v-model="fitbitModal"
    :disableClose="true"
  />
  <StageReportModal
    v-if="stageReportModal.isVisible"
    v-model="stageReportModal.isVisible"
  />
  <StreakProgress
    v-if="streakProgressModal.isVisible"
    v-model="streakProgressModal.isVisible"
  />
  <ToolModal
    v-if="toolModal.isVisible"
    v-model="toolModal.isVisible"
    v-model:toolObject="toolModal.props.toolObject"
    :newTool="toolModal.props.toolNew"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { mapStores } from 'pinia'
import { useModalStore } from '@/stores/modal'
import { useUserStore } from '@/stores/user'
import { FitbitAuth } from '@/helpers/fitbit'
import Modal from '@/models/modal'

export default {
  name: 'AppModalSelector',
  components: {
    FitbitModal: defineAsyncComponent(
      () => import('@/components/modals/FitbitModal'),
    ),
    StageReportModal: defineAsyncComponent(
      () => import('@/components/modals/StageReportModal'),
    ),
    StreakProgress: defineAsyncComponent(
      () => import('@/components/modals/StreakProgress'),
    ),
    ToolModal: defineAsyncComponent(
      () => import('@/components/modals/ToolModal'),
    ),
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      fitbitModal: false,
      stageReportModal: false,
      streakProgressModal: false,
      toolModal: false,
    }
  },
  beforeMount() {
    this.loadModals()
  },
  watch:{
    $route: {
      async handler() {
        this.fitbitModal = await this.fitbitAuthRequired()
      },
      immediate: true,
    },
  },
  methods: {
    async loadModals() {
      await this.modalStore.load()
      this.stageReportModal = this.modalStore.get(Modal.MODAL_STAGE_REPORT)
      this.streakProgressModal = this.modalStore.get(Modal.MODAL_STREAK_PROGRESS)
      this.toolModal = this.modalStore.get(Modal.MODAL_TOOL)
    },
    async fitbitAuthRequired() {
      // If admin is enabled, disable Fitbit auth modal.
      if (this.userStore.admin) {
        return false
      }

      const fitbitAPI = new FitbitAuth()
      const fitbit = await fitbitAPI.isConnected()

      if (!fitbit && this.$route.meta.requiresAccount && !this.$route.path.startsWith('/onboarding')) {
        return true
      }
      return false
    },
  },
  computed: {
    ...mapStores(useModalStore, useUserStore),
  }
}
</script>